export const ADD_VOICE_TEMPLATE: string = "ADD_VOICE_TEMPLATE";
export const CLEAR_VOICE_TEMPLATES: string = "CLEAR_VOICE_TEMPLATES";

export function addVoiceTemplate(templateId: string, channelId:number,name:string, status:number, body:string): IAddVoiceTemplateActionType {
    return { type: ADD_VOICE_TEMPLATE, templateId:templateId, channelId:channelId, name:name, status:status, body:body}
}
export function clearVoiceTemplates(): IClearVoiceTemplateActionType {
    return { type: CLEAR_VOICE_TEMPLATES};
}


interface IAddVoiceTemplateActionType { 
    type:string,
    templateId: string, 
    channelId:number,
    name:string, 
    status:number, 
    body:string
}
interface IClearVoiceTemplateActionType { type:string }